var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { purchaseError, productUpdated, purchaseApproved, } from '../redux/purchaseSlice';
let storeInitialized = false;
export const initializeStore = (dispatch) => {
    if (storeInitialized) {
        console.warn('Store is already initialized. Skipping re-initialization.');
        return;
    }
    storeInitialized = true;
    if (typeof CdvPurchase === 'undefined') {
        console.error('CdvPurchase is not defined. Ensure the app is running on a device or emulator with Capacitor and cordova-plugin-purchase installed.');
        dispatch(purchaseError('In-app purchase plugin not available.'));
        return;
    }
    console.log('CdvPurchase', CdvPurchase);
    const { store, ProductType } = CdvPurchase;
    document.addEventListener('deviceready', () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log('Device is ready. Initializing store...');
            // Set verbosity for debugging
            store.verbosity = store.DEBUG;
            // Register Products
            store.register([
                // Android Products
                {
                    id: 'zooit-supporter-monthly',
                    alias: 'Zooit Supporter: Monthly Subscription',
                    type: ProductType.SUBSCRIPTION,
                    platform: 'android', // Specifies this is for Google Play
                },
                {
                    id: 'zooit-supporter-weekly',
                    alias: 'Zooit Supporter: Weekly Subscription',
                    type: ProductType.SUBSCRIPTION,
                    platform: 'android',
                },
                {
                    id: 'zooit-supporter-yearly',
                    alias: 'Zooit Supporter: Yearly Subscription',
                    type: ProductType.SUBSCRIPTION,
                    platform: 'android',
                },
                // iOS Products
            ]);
            // Add listeners
            store.when('product').updated((product) => {
                console.log('Product updated:', product);
                dispatch(productUpdated(product));
            });
            store.when('product').approved((transaction) => {
                console.log('Purchase approved:', transaction);
                dispatch(purchaseApproved(transaction));
                transaction.finish();
            });
            store.error((error) => {
                console.error('Store error:', error);
                dispatch(purchaseError(`${error.code}: ${error.message}`));
            });
            // Initialize and refresh the store
            console.log('Calling store.initialize with platform android...');
            yield store.initialize(['android']);
            console.log('Store initialized successfully.');
            yield store.update();
            console.log('Product data updated.');
        }
        catch (error) {
            console.error('Error during store initialization:', error);
            dispatch(purchaseError('Store initialization failed.'));
        }
    }));
};
